


// // TeamPDFDocument.js
// import React from 'react';
// import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';

// // Styles
// const styles = StyleSheet.create({
//   page: { padding: 24, fontSize: 9, fontFamily: 'Helvetica', backgroundColor: '#FFFFFF' },
//   header: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14, borderBottomWidth: 1, borderBottomColor: '#E2E8F0', borderBottomStyle: 'solid', paddingBottom: 6 },
//   teamTitle: { fontSize: 14, fontWeight: 'bold', color: '#0F172A' },
//   timestamp: { fontSize: 8.5, color: '#64748B' },
//   sectionHeading: { fontSize: 12, fontWeight: 'bold', color: '#1C509C', backgroundColor: '#E0F2FE', padding: 6, marginBottom: 10, marginTop: 10, borderRadius: 4 },
//   grid: { flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between' },
//   card: { width: '48.5%', height: 110, borderWidth: 1, borderColor: '#E2E8F0', borderStyle: 'solid', borderRadius: 6, padding: 10, marginBottom: 10, flexDirection: 'row', alignItems: 'center', backgroundColor: '#FAFAFA', },
//   imageWrapper: { width: 44, height: 44, borderRadius: 22, overflow: 'hidden', backgroundColor: '#CBD5E1', marginRight: 10, },
//   image: { width: '100%', height: '100%', objectFit: 'cover', },
//   info: { flex: 1, justifyContent: 'center', },
//   name: { fontSize: 10, fontWeight: 'bold', color: '#0F172A', marginBottom: 2, textTransform: 'uppercase', },
//   designation: { fontSize: 8.5, color: '#0D9488', fontWeight: 'bold', marginBottom: 3, },
//   text: { fontSize: 8, color: '#334155', marginTop: 1, lineHeight: 1.2, },
//   location: { fontSize: 7.5, marginTop: 4, color: '#64748B', fontStyle: 'italic', },
// });

// // Main PDF Component
// const TeamPDFDocument = ({ teamName, members = [] }) => {
//   const timestamp = new Date().toLocaleString();
//   const isMasterReport = teamName.includes("All Leadership") || teamName.includes("Master");

//   // Group members by leadership_team if it's a master report, otherwise group under the provided teamName
//   const groupedData = members.reduce((acc, member) => {
//     const groupKey = isMasterReport ? (member.leadership_team || "Other Leaders") : teamName;
//     if (!acc[groupKey]) {
//       acc[groupKey] = [];
//     }
//     acc[groupKey].push(member);
//     return acc;
//   }, {});

//   // Flatten out into chunks or structured sections depending on page limits, maintaining heading association
//   const sections = Object.entries(groupedData);

//   return (
//     <Document>
//       <Page size="A4" style={styles.page}>
//         {/* Header */}
//         <View style={styles.header}>
//           <Text style={styles.teamTitle}>{teamName || 'Team Directory'}</Text>
//           <Text style={styles.timestamp}>{timestamp}</Text>
//         </View>

//         {sections.map(([heading, groupMembers], sIndex) => (
//           <View key={sIndex}>
//             {/* Render Heading Section Banner if Master or multi-group */}
//             {isMasterReport && <Text style={styles.sectionHeading}>{heading}</Text>}

//             <View style={styles.grid}>
//               {groupMembers.map((leader, i) => (
//                 <View key={leader.id || i} style={styles.card} wrap={false}>
//                   {leader.image ? (
//                     <View style={styles.imageWrapper}>
//                       <Image src={leader.image} style={styles.image} />
//                     </View>
//                   ) : null}

//                   <View style={styles.info}>
//                     <Text style={styles.name}>{leader.name || 'Not Available'}</Text>
//                     {leader.desegnation ? (
//                       <Text style={styles.designation}>{leader.desegnation}</Text>
//                     ) : null}
//                     <Text style={styles.text}>
//                       Mo: {leader.number || leader.mobile || 'N/A'}
//                     </Text>
//                     {leader.email ? (
//                       <Text style={styles.text}>{leader.email}</Text>
//                     ) : null}
//                     {leader.location || leader.address ? (
//                       <Text style={styles.location}>
//                         {leader.location || leader.address}
//                       </Text>
//                     ) : null}
//                   </View>
//                 </View>
//               ))}
//             </View>
//           </View>
//         ))}
//       </Page>
//     </Document>
//   );
// };

// export default TeamPDFDocument;



// TeamPDFDocument.js
import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: { 
    padding: 24, 
    fontSize: 9, 
    fontFamily: 'Helvetica', 
    backgroundColor: '#FFFFFF',
    flexDirection: 'column'
  },
  header: { 
    flexDirection: 'row', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    marginBottom: 8, 
    borderBottomWidth: 1, 
    borderBottomColor: '#E2E8F0', 
    paddingBottom: 4 
  },
  teamTitle: { fontSize: 13, fontWeight: 'bold', color: '#0F172A' },
  timestamp: { fontSize: 8, color: '#64748B' },
  sectionHeading: { 
    fontSize: 11, 
    fontWeight: 'bold', 
    color: '#1C509C', 
    backgroundColor: '#E0F2FE', 
    padding: 5, 
    marginBottom: 8, 
    borderRadius: 4 
  },
  grid: { 
    flexDirection: 'row', 
    flexWrap: 'wrap', 
    justifyContent: 'space-between' 
  },
  card: { 
    width: '48.5%', 
    height: 108, 
    borderWidth: 1, 
    borderColor: '#E2E8F0', 
    borderRadius: 6, 
    padding: 8, 
    marginBottom: 8, 
    flexDirection: 'row', 
    alignItems: 'center', 
    backgroundColor: '#FAFAFA' 
  },
  imageWrapper: { 
    width: 44, 
    height: 44, 
    borderRadius: 22, 
    overflow: 'hidden', 
    backgroundColor: '#CBD5E1', 
    marginRight: 8,
    flexShrink: 0 
  },
  image: { width: '100%', height: '100%', objectFit: 'cover' },
  info: { flex: 1, justifyContent: 'center' },
  name: { fontSize: 9.5, fontWeight: 'bold', color: '#0F172A', marginBottom: 2, textTransform: 'uppercase' },
  designation: { fontSize: 8, color: '#0D9488', fontWeight: 'bold', marginBottom: 2 },
  districtBadge: { fontSize: 7.5, color: '#1C509C', fontWeight: 'bold', marginBottom: 2 },
  text: { fontSize: 7.5, color: '#334155', marginTop: 1, lineHeight: 1.2 },
  location: { fontSize: 7, marginTop: 2, color: '#64748B', fontStyle: 'italic' },
  footer: { 
    position: 'absolute', 
    bottom: 12, 
    left: 24, 
    right: 24, 
    textAlign: 'center', 
    fontSize: 7.5, 
    color: '#94A3B8' 
  }
});

// Helper to chunk arrays into fixed page sizes (8 cards per page)
const chunkArray = (arr, size) => {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
};

// Recognised Multiple Districts order in India
const MD_LIST = [
  "316", "317", "318", "320", "321", "322",
  "3231", "3232", "3233", "3234", "3241", "3242"
];

const TeamPDFDocument = ({ teamName, members = [] }) => {
  const timestamp = new Date().toLocaleString();
  const isMasterReport = teamName.includes("All Leadership") || teamName.includes("Master");

  // 1. FILTER OUT EMPTY DUMMY RECORDS FROM API (e.g. IDs with blank names & roles)
  const validMembers = members.filter((m) => {
    return (m.name && m.name.trim() !== "") || (m.number && m.number.toString().trim() !== "");
  });

  const groupedData = {};

  if (isMasterReport) {
    // -------------------------------------------------------------
    // MASTER REPORT: Group into National Teams FIRST, then Multiple Districts
    // -------------------------------------------------------------

    // A. National leadership teams
    validMembers.forEach((member) => {
      const team = (member.leadership_team || "").trim();
      const isGovRole = 
        team.toLowerCase().includes("district governor") || 
        team.toLowerCase().startsWith("multiple district");

      if (!isGovRole && team) {
        if (!groupedData[team]) groupedData[team] = [];
        groupedData[team].push(member);
      }
    });

    // B. Multiple Districts (316, 317, ..., 3234, etc.)
    MD_LIST.forEach((mdCode) => {
      const mdTitle = `Multiple District ${mdCode}`;
      const mdMembers = validMembers.filter((m) => {
        const d = (m.district || "").replace(/[\s-]/g, "").toUpperCase();
        const t = (m.leadership_team || "").replace(/[\s-]/g, "").toUpperCase();
        // Check if member is a governor/leader matching this MD code
        return d.includes(`MD${mdCode}`) || d.includes(mdCode) || t.includes(`DISTRICT${mdCode}`);
      });

      if (mdMembers.length > 0) {
        groupedData[mdTitle] = mdMembers;
      }
    });

  } else {
    // -------------------------------------------------------------
    // SINGLE TEAM OR SINGLE MULTIPLE DISTRICT REPORT
    // -------------------------------------------------------------
    groupedData[teamName] = validMembers;
  }

  // Pre-split every section into pages of 8 cards
  const pagesList = [];
  Object.entries(groupedData).forEach(([heading, groupMembers]) => {
    const chunks = chunkArray(groupMembers, 8);
    chunks.forEach((chunk, pageIndex) => {
      pagesList.push({
        heading: pageIndex === 0 ? heading : `${heading} (Contd.)`,
        members: chunk
      });
    });
  });

  return (
    <Document>
      {pagesList.map((pageData, pIdx) => (
        <Page key={pIdx} size="A4" style={styles.page}>
          <View style={styles.header}>
            <Text style={styles.teamTitle}>{teamName || 'Team Directory'}</Text>
            <Text style={styles.timestamp}>{timestamp}</Text>
          </View>

          <Text style={styles.sectionHeading}>{pageData.heading}</Text>

          <View style={styles.grid}>
            {pageData.members.map((leader, i) => (
              <View key={leader.id || i} style={styles.card}>
                {leader.image ? (
                  <View style={styles.imageWrapper}>
                    <Image src={leader.image} style={styles.image} />
                  </View>
                ) : null}

                <View style={styles.info}>
                  <Text style={styles.name}>{leader.name || 'Not Available'}</Text>

                  {leader.district ? (
                    <Text style={styles.districtBadge}>District: {leader.district}</Text>
                  ) : null}

                  {leader.desegnation ? (
                    <Text style={styles.designation}>{leader.desegnation}</Text>
                  ) : null}

                  {leader.number ? (
                    <Text style={styles.text}>Mo: {leader.number}</Text>
                  ) : null}

                  {leader.email ? (
                    <Text style={styles.text}>{leader.email}</Text>
                  ) : null}

                  {leader.location ? (
                    <Text style={styles.location}>{leader.location}</Text>
                  ) : null}
                </View>
              </View>
            ))}
          </View>

          <Text 
            style={styles.footer} 
            render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`} 
            fixed 
          />
        </Page>
      ))}
    </Document>
  );
};

export default TeamPDFDocument;